import { render, staticRenderFns } from "./_Form.vue?vue&type=template&id=28b1ed38&scoped=true&"
import script from "./_Form.vue?vue&type=script&lang=js&"
export * from "./_Form.vue?vue&type=script&lang=js&"
import style0 from "./_Form.vue?vue&type=style&index=0&id=28b1ed38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1ed38",
  null
  
)

export default component.exports